up.compiler(".up_delete_workshop", function (element) {
  const cancelButton = element.querySelector("button#js-cancel");
  const confirmButton = element.querySelector("button#js-confirm");
  function cancel() {
    up.layer.current.dismiss();
  }
  function confirm() {
    setTimeout(() => {
      up.layer.current.dismiss();
      setTimeout(() => {
        up.layer.current.dismiss();
        setTimeout(() => {
          up.render({
            url: `/manage-workshops/remove-workshop/${element.dataset.freskslug}/${element.dataset.workshopslug}`,
            method: "delete",
            target: ".main",
          });
        }, 130);
      }, 130);
    }, 130);
  }
  cancelButton.addEventListener("click", cancel);
  confirmButton.addEventListener("click", confirm);
  return () => {
    cancelButton.removeEventListener("click", cancel);
    confirmButton.removeEventListener("click", confirm);
  };
});
